//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex'
import {
    GET_SELECTED_CHAT,
    GET_BOT_BY_ID,
    GET_CSS_PROPERTY_SUPPORTED,
    GET_SERVER_API,
    GET_MERGED_CONTACT_BY_ID,
    IS_CHAT_ADMIN,
    GET_SELECTED_MSGS,
} from '../../store/gettersTypes'
import {
    ACT_INFO_PUSH,
    ACT_CHAT_UPDATE_REPLY,
    ACT_CHAT_UPDATE_EDITED,
    CALLS_CONTROLLER,
    ACT_CHANGE_CHAT,
    ACT_CHAT_SET_MSG_ENTITIES,
    ACT_SCHEDULE_RESPONSE_TO_INVITATION,
    ACT_PUSH_MAIN_TYPE,
    ACT_SET_SELECTED_MSGS,
} from '../../store/actionsTypes'
import {
    CHATS,
    INFO,
    BOTS,
    CLIENTDATA,
    CHAT,
    PHONE_CNTL,
    LOGIN,
    CONTACTS,
    INTEGRATIONS,
    CONTENT_MANAGER,
} from '../../store/modulesNames'
import SelectChatToForward from  '../modal/SelectChatToForward.vue'
import ChatAudioMessage from './ChatAudioMessage.vue'
import ChatChannelMessage from './ChatChannelMessage.vue'
import ChatContactMessage from './ChatContactMessage.vue'
import ChatGeoMessage from './ChatGeoMessage.vue'
import ChatGroupedMessage from './ChatGroupedMessage.vue'
import ChatImageMessage from './ChatImageMessage.vue'
import ChatRegularFileMessage from './ChatRegularFileMessage.vue'
import ChatReplyMessage from './ChatReplyMessage.vue'
import ChatVideoMessage from './ChatVideoMessage.vue'
import ChatPollMessage from '../chatPollMessage.vue'
import ChatPublicationMessage from './ChatPublicationMessage.vue'
import ReferenceMsg from './ReferenceMsg.vue'
import BotKeyboardMsg from '../bots/BotKeyboardMsg.vue'
import ChatCallAvailabilityMessage from './ChatCallAvailabilityMessage.vue'
import ChatSurveyMessage from '../chatSurveyMessage.vue'
import ChatScheduleMessage from '../chatScheduleMessage.vue'
import ChatMessageMixin from "./chat-message-mixin"
import EnterConf from '../videoConfNewManagment/enterConference.vue'
import DelChatMessage from "../modal/DelChatMessage.vue"
import CheckBox from "../custom/CustomCheckboxRound.vue"
import ForwardMultipleMessages from '../modal/SelectChatToForwardMessages.vue'
import DeleteMultipleMessages from '../modal/DeleteMultipleMessages.vue'

import { DLP_SOURCE_TYPES } from '../../store/modules/dlp'
import { MAIN_TYPES } from '../../store/modules/content-manager'
import {CONTACT_FIELD_TYPES} from '../../constants'

export default {
    name: 'chat-message',
    mixins: [ChatMessageMixin],
    components: {
        'chat-contact-message': ChatContactMessage,
        'chat-geo-message': ChatGeoMessage,
        ChatGroupedMessage,
        'chat-image-message': ChatImageMessage,
        'chat-video-message': ChatVideoMessage,
        'chat-audio-message': ChatAudioMessage,
        'chat-regular-file-message': ChatRegularFileMessage,
        'chat-channel-message': ChatChannelMessage,
        'chat-reply-message': ChatReplyMessage,
        'chat-poll-message': ChatPollMessage,
        'chat-publication-message': ChatPublicationMessage,
        'bot-keyboard-msg': BotKeyboardMsg,
        'chat-call-availability-message': ChatCallAvailabilityMessage,
        'reference-msg': ReferenceMsg,
        ChatSurveyMessage,
        ChatScheduleMessage,
        CheckBox,
        ForwardMultipleMessages,
        DeleteMultipleMessages,
    },
    props: ['message', 'cid', 'type', 'withAnimation', 'maximagesize', 'isSelectMode'],
    data() {
        return {
            displayStyle: 'block',
            shortMsg: true,
            animation: this.withAnimation,
            maxHeight: 0,
            withText: false,
            maxCharsWithShortMessage: 1000,
            secondContextMenuHandlers: [],
            isSurveyOpened: false,
            isSelectModeOn: false,
            isSelected: false,
            selectedMessages: []
        }
    },
    mounted () {
        if (!this.animation) return
        this.$nextTick(() => {
            this.maxHeight = this.$el.scrollHeight
            let nodeWithImg = this.$el.querySelector('.chat-image-message, .chat-video-message, .chat-channel-message, .chat-publication-message')
            if (nodeWithImg) nodeWithImg = nodeWithImg.querySelector('img')
            if (nodeWithImg && nodeWithImg.scrollHeight === 0) this.maxHeight += 250

            setTimeout(() => {
                this.animation = false
            }, 300)
            if (this.maxHeight) this.$nextTick(() => this.$el.classList.add('animation'))
        })
    },
    watch: {
        [GET_SELECTED_MSGS](val) {
            this.selectedMessages = val
        },
    },
    computed: {
        ...mapGetters(LOGIN, [GET_SERVER_API]),
        ...mapGetters(CHAT, [GET_SELECTED_MSGS]),
        ...mapGetters(CHATS, [GET_SELECTED_CHAT, IS_CHAT_ADMIN]),
        ...mapGetters(BOTS, [GET_BOT_BY_ID]),
        ...mapGetters(CLIENTDATA, [GET_CSS_PROPERTY_SUPPORTED]),
        ...mapGetters(CONTACTS, [GET_MERGED_CONTACT_BY_ID]),
        overflowAnchorSupported() { return this[GET_CSS_PROPERTY_SUPPORTED]('overflowAnchor')},
        is_member() {
            let member = false
            try {
                let cid = this.$store.state.chat.cid
                let chats = this.$store.state.chats.chats
                let uid = this.$store.getters['userdata/getUid'];
                let contacts

                if (this[GET_SELECTED_CHAT].cidType === 'group') {
                    for (let i in chats) {
                        if (chats[i].cid === cid && chats[i].cidType === 'group') {
                            contacts = chats[i].contacts
                            break
                        }
                    }
                    for (let i in contacts) {
                        if (contacts[i].cid === uid) {
                            member = true
                            break
                        }
                    }
                } else {
                    member = true
                }
            } catch (e) {
                console.log(e)
            }
            return member
        },
        bot() {
            return this.message.cidType === 'user' && this[GET_BOT_BY_ID](this.cid)
        },
        contact() {
            if (this.cid === 0) return this.$store.getters['chats/getChat']({ cid: this.cid, cidType: 'user' })
            else if (this.message.cidType === 'group') return this.$store.getters['contacts/getMergedContactById'](this.message.senderId)
            else if (this.message.cidType === 'user') return this.$store.getters['contacts/getMergedContactById'](this.cid)
            else return {}
        },
        name() {
            return (this.bot ? this.bot[CONTACT_FIELD_TYPES.BOTTITLE] : this.contact.fio) || ''
        },
        nameSignature() {
            if (this.message.cidType === 'group' && !this.message.ownMsg && (this.message.seriesMessagesStart || this.type === 'detail-msg'))
                return this.name
        },
        side() {
            return this.message.type === 'system' ? 'center' : ((this.message.ownMsg ? 'right' : 'left'))
        },
        photo() {
            if (this.message.seriesMessagesEnd && !this.message.ownMsg && this.message.type !== 'system' && this.type !== 'detail-msg') {
                return this.bot ? this.bot.photo : this.contact.photo
            }
        },
        messageMouthRight () {
            if(this.message.type === 'system') return false
            return (this.message.ownMsg && (!!this.message.msg.text || this.message.seriesMessagesEnd)) || (this.type === 'detail-msg' && this.side === 'right')
        },
        msgPosition() {
            if(this.type === 'detail-msg' && this.side === 'right') return {'msg-right': true};
            else if(this.type === 'detail-msg' && this.side === 'left') return {'msg-left': true};
        },
        marginLeftMsg() {
            if(this.type === 'detail-msg') return '0px';
            if(!this.message.ownMsg && this.message.type !== 'system' && !this.photo) return '44px'
            else return '12px';
        },
        classes() {
            let classes = []
            if (this.message.type === 'system') classes.push('system-message')
            if (this.message.sub_type === 'time') classes.push('time')
            if (this.message.type === 'data') classes.push('data-message')
            if (this.message.type === 'time') classes.push('time-message')

            if (this.type === 'detail-msg') classes.push('detail-msg')
            if (this.message.type !== 'system') {
                if (this.message.seriesMessagesStart) classes.push('series-message-start')
                if (this.message.seriesMessagesEnd) classes.push('series-message-end')
                if (!this.message.seriesMessagesStart) classes.push('series-message')
                const indexSelectMode = classes.indexOf('select-mode')
                const indexSelected = classes.indexOf('selected-message')
                if (this.isSelectMode) {
                    if (indexSelectMode === -1) classes.push('select-mode')
                    if (this.isMessageSelected(this.message.id)) classes.push('selected-message')
                    else if (indexSelected > -1) classes.splice(indexSelected, 1)
                } else {
                    if (indexSelectMode > -1) classes.splice(indexSelectMode, 1)
                    if (indexSelected > -1) classes.splice(indexSelected, 1)
                }
            }
            classes.push(`side-${this.side}`)
            if (this.animation) {
                classes.push('last')
                if (this.overflowAnchorSupported)  classes.push('height-change')
            }
            if (this.message.edited) classes.push('edited')
            return classes
        },
        style() {
            const styles = (this.animation && this.maxHeight) ? {'--max-height': `${this.maxHeight}px`} : {}
            if (!['image','video'].includes(this.message.sub_type)) 
            Object.assign(styles, {'--margin-caption-top': '1em'})
            if (!['image', 'video', 'file'].includes(this.message.sub_type)) return styles

            const defaultSideSize = 250
            const msg = this.message.msg
            const availHeight = window.screen.availHeight * 0.33
            const maxWidth = this.maximagesize && Math.min(availHeight, this.maximagesize.width * Math.min(this.maximagesize.height / this.maximagesize.width, 0.6)) || defaultSideSize
            Object.assign(styles, { '--text-max-width': maxWidth + 'px' })
            if (!msg.previewSize || !(msg.previewSize.w && msg.previewSize.h)) {
                Object.assign(styles, {
                    '--preview-block-max-width': `${defaultSideSize}px`,
                    '--preview-block-max-height': `${defaultSideSize}px`,
                    '--image-max-width': '100%',
                    '--image-max-height': '100%',
                })
            } else {
                let width
                let height
                const minSide = 100
                const maxHeight = this.maximagesize && availHeight || defaultSideSize
                const previewWidth = msg.previewSize && msg.previewSize.w || defaultSideSize
                const previewHeight = msg.previewSize && msg.previewSize.h || defaultSideSize
                const widthProportion = previewWidth / maxWidth
                const heightProportion = previewHeight / maxHeight
                if (previewWidth > maxWidth || previewHeight > maxHeight) {
                    if (widthProportion > heightProportion) {
                        width = maxWidth
                        height = maxWidth * previewHeight / previewWidth
                    } else if (widthProportion < heightProportion) {
                        width = maxHeight * previewWidth / previewHeight
                        height = maxHeight
                    } else {
                        width = maxWidth
                        height = maxHeight
                    }
                } else if (previewWidth < minSide && previewHeight < minSide) {
                    if (previewWidth > previewHeight) {
                        width = minSide
                        height = minSide * previewHeight / previewWidth
                    } else if (previewHeight > previewWidth) {
                        width = minSide * previewWidth / previewHeight
                        height = minSide
                    } else {
                        width = minSide
                        height = minSide
                    }
                } else {
                    width = previewWidth
                    height = previewHeight
                }
                let groupWidth = width / 2 < 140 ? 140 : width / 2
                Object.assign(styles, {
                    '--image-width': width + 'px',
                    '--image-height': height + 'px',
                })
                if (this.message && this.message.fileGroupId) {
                    Object.assign(styles, {
                        '--group-image-width': groupWidth + 'px',
                        '--text-max-width': (2*groupWidth - 8) + 'px'
                    })
                }
            }
            return styles
        },
        messageWrapperClasses() {
            return {
                'message-mouth-left-detail': this.type === 'detail-msg' && this.side === 'left',
                'message-mouth-right': this.messageMouthRight,
                ...this.msgPosition
            }
        },
        isSelectedMsgs() {
            return this.selectedMessages.length
        },
        isChecked() {
            return this.isMessageSelected(this.message.id)
        },
        textIndentClasses() {
            let indentClass = 'text-indent'
            if (this.message.edited) {
                indentClass += ` edited-${this.$i18n.locale}`
            }
            return indentClass
        },
        readOnly() {
            return this.message && this.message.msg && this.message.msg.readOnly
        }
    },
    methods: {
        textContinue() {
            return this.shortMsg && this.msgTextLength > this.maxCharsWithShortMessage;
        },
        msgTextHtml(text, entities) {
            if (!text) return ''
            text = text.replace(/</g,'\x7F').replace(/>/g,'\x8F')
            if (entities) {
                text = this.messageTextFormat(entities, text)
            }
            else {
                text = this.lookForLinks(text)
            }
            let imgEmojisArr = this.getEmojiNative(text)
            let emoCount = imgEmojisArr ? imgEmojisArr.length : 0

            let parser = new DOMParser()
            let dom = parser.parseFromString(text, 'text/html')
            let textLength = dom.body.textContent.length
            if (emoCount && textLength === 2*emoCount) {
                text = this.wrapEmoji(`<span>` + text + `<\span>`)
                text = this.setEmojisSpecialStyles(text)
            }
            else text = this.wrapEmoji(text)
            this.msgTextLength = textLength + emoCount
            if (this.textContinue()) {
                text = this.getSlicedText(dom) + '<span>...</span>'
            }

            if (!this.textContinue()) {
                const indentSpan = `<span ${this.$options._scopeId} class="${this.textIndentClasses}"></span>`
                text += indentSpan
            }
            this.withText = true
            text = text.replace(/\x7F/g,'&lt;').replace(/\x8F/g,'&gt;')
            return text
        },
        groupMsgText(message) {
            const lastGroupMsg = message.groupMsgs && message.groupMsgs[message.groupMsgs.length -1]
            return lastGroupMsg.text || ''
        },
        setEmojisSpecialStyles(text) {
            let dom = new DOMParser().parseFromString(text, 'text/html')
            let emos = dom.querySelectorAll('.emoji.emojibgrd')
            const emoCount = emos.length
            let span = dom.getElementsByTagName("span")[0]
            emos.forEach((emo, index) => {
                let emoStyle = emo.style
                emoStyle.verticalAlign = "middle"
                if (emoCount === 1) {
                    emoStyle.transform = "scale(2)"
                    span.style = `line-height: 2.6em;`
                    emoStyle.marginLeft = "0.6em"
                    emoStyle.marginRight = "0.4em"
                }
                if (emoCount === 2) {
                    emoStyle.transform = "scale(1.6)"
                    span.style = `line-height: 2.2em;`
                    emoStyle.marginLeft = "0.2em"
                    if (index > 0) {
                        emoStyle.marginLeft = "1em"
                        emoStyle.marginRight = "0.1em"
                    }
                }
                if (emoCount === 3) {
                    emoStyle.transform = "scale(1.3)"
                    span.style = `line-height: 1.8em;`
                    emoStyle.marginLeft = "0.2em"
                    if (index > 0) emoStyle.marginLeft = "0.6em" 
                }
            });
            return dom.body.innerHTML
        },
        checkReference (text, textEntities = []) {
            if (text && text.length) {
                const isOldRefFormat = text.search(/^@\[|\s@\[/) > -1
                let isNewRefFormat = false
                if (textEntities) {
                    isNewRefFormat = textEntities.some && textEntities.some(ent => ent.hasOwnProperty('contactId') || ent.hasOwnProperty('channelId') || ent.hasOwnProperty('botId')|| ent.hasOwnProperty('botCommand'))
                }

                if (isOldRefFormat || isNewRefFormat) {
                    this.withText = true
                    return true
                }
                return false
            }
        },
        getSelected(id) {
            return Boolean(this.isMessageSelected(id))
        },
        onSelectMessage(message, val) {
            const id = message.id, isGroupMsgs = message.hasOwnProperty('groupMsgs')
            const isExist = this.selectedMessages.includes(id)
            if (!isExist && val) {
                this.$nextTick(() => {
                    this.$emit('setselectmode', true)
                })
                if (isGroupMsgs) {
                    for (let index = 0; index < message.groupMsgs.length; index++) {
                        const msg = message.groupMsgs[index]
                        this.selectedMessages.push(msg.msgId) 
                    }
                } else this.selectedMessages.push(id)
                this.isSelected = true
            }
            if (isExist && !val) {
                if (isGroupMsgs) {
                    for (let index = 0; index < message.groupMsgs.length; index++) {
                        let index = this.selectedMessages.indexOf(id)
                        this.selectedMessages.splice(index, 1)                        
                    }
                } else {
                    let index = this.selectedMessages.indexOf(id)
                    this.selectedMessages.splice(index, 1)
                }
                this.isSelected = false
            }
            this[ACT_SET_SELECTED_MSGS](this.selectedMessages)
        },
        isMessageSelected(id) {
            return Boolean(this.selectedMessages.length && this.selectedMessages.indexOf(id) > -1)
        },
        fioById(cid) {
            return this[GET_MERGED_CONTACT_BY_ID](cid).fio || null
        },
        getDateStamp(message) {
            if (message.dateTime) return message.dateTime;
        },
        async openLinkContextMenu(e) {
            if (navigator.platform.toUpperCase().indexOf('MAC')>=0) await (m => new Promise((resolve) => setTimeout(resolve, m)))(100)
            let { event, link } = e.detail
            let handlers = []
            let open = this.cmOpen
            handlers.push({ item_name: this.$t('open-link'), handler: this.openUrlLink, data: link })
            handlers.push({ item_name: this.$t('copy-link'), handler: this.copyToClipboard, data: link })
            open(event, handlers, 'right-bottom')
        },
        openUrlLink(link) {
            window.openLink(link)
        },
        openSurvey(isSurveyOpened) {
            this.isSurveyOpened = isSurveyOpened
        },
        async openEmailContextMenu(e) {
            if (navigator.platform.toUpperCase().indexOf('MAC')>=0) await (m => new Promise((resolve) => setTimeout(resolve, m)))(100)
            let { event, email } = e.detail
            let handlers = []
            let open = this.cmOpen
            handlers.push({ item_name: this.$t('mainPage.write-email'), handler: window.doEmail, data: email })
            handlers.push({ item_name: this.$t('mainPage.copy-email'), handler: this.copyToClipboard, data: email })
            open(event, handlers, 'right-bottom')
        },
        async openVCContextMenu(e) {
            if (navigator.platform.toUpperCase().indexOf('MAC')>=0) await (m => new Promise((resolve) => setTimeout(resolve, m)))(100)
            let { event, type, vcLink } = e.detail
            let handlers = []
            let open = this.cmOpen
            handlers.push({ item_name: this.$t('videomost.join'), handler: this.joinVideoConf, data: {type, vcLink} })
            handlers.push({ item_name: this.$t('copy-link'), handler: this.copyToClipboard, data: vcLink })
            open(event, handlers, 'right-bottom')
        },
        async openPhoneNumberContextMenu(e) {
            if (navigator.platform.toUpperCase().indexOf('MAC')>=0) await (m => new Promise((resolve) => setTimeout(resolve, m)))(100)
            let { event, number } = e.detail
            let handlers = []
            let open = this.cmOpen
            handlers.push({ item_name: this.$t('chat.call'), handler: this.makeCallByNumber, data: number })
            handlers.push({ item_name: this.$t('copy-number'), handler: this.copyToClipboard, data: number })
            open(event, handlers, 'right-bottom')

        },
        async callPhoneNumberByClick(e) {
            let { number } = e.detail
            if (number) this.makeCallByNumber(number)
        },
        async doOnClick(event, message) {
            if (message && message.type === 'data' && message.sub_type === 'call-availability') {
                let handlers = []
                handlers.push({ item_name: this.$t('chat.call'), handler: this.call, data: message.msg })
                if ('cid' in message.msg) handlers.push({ item_name: this.$t('chat.profile'), handler: this.openProfile, data: message.msg.cid })
                else handlers.push({ item_name: this.$t('chat.copy'), handler: this.copyToClipboard, data: message.msg.number })
                this.cmOpen(event, handlers, 'right-bottom', {offsetX: 5, offsetY: 5})
            }
        },
        getPureTextFromHtml(inHtml) {
            let parser = new DOMParser()
            let dom = parser.parseFromString(inHtml, 'text/html')
            return dom.body.textContent
        },
        async doContextMenu(event, message) {
            if (navigator.platform.toUpperCase().indexOf('MAC')>=0) await (m => new Promise((resolve) => setTimeout(resolve, m)))(100)
            let handlers = []
            let voteResult = this.$store.getters['chat/getPollVoteById'](message.msg.pollId)
            let text = ''
            const entities = message.entities || []
            const isSurvey = message.type === 'data' && message.msg.type === 'survey'
            const isSchedule = message.type === 'data' && message.msg.type === 'schedule'
            const isSpecialMessage = isSurvey || isSchedule
            const isImage = message.type === 'data' && message.sub_type === 'image' && message.msg.file
            const isGroupMsgs = message.hasOwnProperty('groupMsgs')

            if (isSchedule) handlers = this.scheduleContextMenu(message.msg)
            if (!isSpecialMessage) handlers = handlers.concat(this.generalSelectModeContextMenu(message))
            if (isImage && !this.isSelectMode && !isGroupMsgs) handlers = handlers.concat(this.imageContextMenu(message))
            if(message.type === 'data' && (['location', 'contact', 'call-availability'].includes(message.sub_type))) {}
            else if (message.type === 'data' && message.msg.type !== 'poll' && message.sub_type !== 'text' && !isSpecialMessage && !this.isSelectMode) {
                handlers = handlers.concat(this.saveFileContextMenu(isGroupMsgs))
            }
            else if (message.type === 'data' && message.msg.type === 'poll' && voteResult && !this.isSelectedMsgs) handlers.push({ item_name: this.$t('cancel-vote'), handler: this.cancelPoll })
            else if (!this.isSelectedMsgs) {
                if (event.target.className === 'e-mail') text = event.target.innerText
                else {
                    text = this.getPureTextFromHtml(message.msg)
                }
                handlers = handlers.concat(this.copyTextContextMenu(text, entities, isSpecialMessage))
            }

            if (this.is_member) {
                const isAdmin = this[IS_CHAT_ADMIN]({cid: message.cid, cidType: message.cidType})
                switch (this.side) {
                    case 'right':
                        await this[ACT_CHAT_SET_MSG_ENTITIES]({text, entities})
                        handlers = handlers.concat(this.rightSideContextMenu(message, isSpecialMessage, isAdmin))
                        break
                    case 'left':
                        handlers = handlers.concat(this.leftSideContextMenu(message, isSpecialMessage, isAdmin))
                        break
                    case 'center':
                        return
                }
            }
            this.cmOpen(event, handlers, 'right-bottom')
        },
        generalSelectModeContextMenu(message) {
            const isGroupMsgs = message.hasOwnProperty('groupMsgs')
            const selectStr = isGroupMsgs ? this.$t('chat.group-messages.select-all') : this.$t('chat.select')
            const copyStr = isGroupMsgs ? this.$t('chat.group-messages.copy-all') : this.$t('chat.select')
            let handlers = []
            if (!this.readOnly) {
                handlers.push({ item_name: this.isSelectMode && this.isChecked ? this.$t('chat.remove-select') : selectStr, handler: () => {
                    if (!this.isSelectModeOn) {
                        this.isSelectModeOn = !this.isSelectModeOn
                        this.onSelectMessage(message, true)
                    } else  {
                        if (this.isChecked) this.onSelectMessage(message, false)
                        else this.onSelectMessage(message, true)
                    }
                    }
                })
            }
            if (this.isSelectedMsgs) {
                    handlers.push({ item_name: copyStr, handler: this.copyMultiple })
            }
            return handlers
        },
        saveFileContextMenu(isGroupMsgs) {
            if (isGroupMsgs) return []
            //const saveStr = isGroupMsgs ? this.$t('chat.group-messages.save-all') : this.$t('save')
            const saveStr = this.$t('save')
            let handlers = []
            if (!this.readOnly)
                // if (isGroupMsgs) handlers.push({ item_name: saveStr, handler: this.doSaveFile() })
                // else 
                handlers.push({ item_name: saveStr, handler: this.doSaveFile })
            return handlers
        },
        copyTextContextMenu(text, entities, isSpecialMessage) {
            let handlers = []
            const isNodeInSelection = this.nodeInSelection(this.$el)
            if (isNodeInSelection) {
                let selectedText = this.getPureTextFromHtml(this.getSelectedText())
                handlers.push({ item_name: this.$t('copy-selected-text'), handler: this.copyToClipboard, data: { text: selectedText, entities } })
            }
            if (!isSpecialMessage && !this.isSelectMode && !isNodeInSelection) {
                handlers.push({ item_name: this.$t('copy'), handler: this.copyToClipboard, data: { text, entities } })
            }
            return handlers
        },
        scheduleContextMenu(msg) {
            let handlers = []
            if (msg.eventType === 'invite'){
                const payload =  { type: "exchange", id: msg.id, response: "accept" }
                handlers.push({item_name: this.$t('integrations.invite-confirm'), handler: () => {
                        this[ACT_SCHEDULE_RESPONSE_TO_INVITATION](payload)
                    }
                })
                handlers.push({item_name: this.$t('integrations.invite-confirm-tentatively'), handler: () => {
                        payload.response = "accept-tentatively"
                        this[ACT_SCHEDULE_RESPONSE_TO_INVITATION](payload)
                    }
                })
                handlers.push({item_name: this.$t('integrations.invite-decline'), handler: () => {
                        payload.response = "decline"
                        this[ACT_SCHEDULE_RESPONSE_TO_INVITATION](payload)
                    }
                })
            }
            handlers.push({item_name: this.$t('integrations.open-calendar'), handler: () => {
                    this[ACT_PUSH_MAIN_TYPE]({type: MAIN_TYPES.MEETINGCALENDAR})
                }
            })
            return handlers
        },
        imageContextMenu(message) {
            let handlers = []
            if (message.hasOwnProperty('groupMsgs')) return handlers
            handlers.push({ item_name: this.$t('chat.copy-image'), handler: async () => {
                        let link = this.$store.getters['userdata/getHost'] + '/' + message.msg.file
                        const blobFile = await this.getBlobFromURL(link)
                        let changedBlob = new Blob([blobFile], {type: 'image/png'})
                        navigator.clipboard.write([new ClipboardItem({ 'image/png' : changedBlob })])
                    }
            })
            return handlers
        },
        rightSideContextMenu(message, isSpecialMessage, isAdmin) {
            const isGroupMsgs = message.hasOwnProperty('groupMsgs')
            const deleteStr = isGroupMsgs ? this.$t('chat.group-messages.delete-all') : this.$t('chat.delete')
            let handlers = []
            if (!this.isSelectMode) {
                handlers.push({ item_name: this.$t('info'), handler: this.showInfoMsg, data: message })
                handlers.push({ item_name: this.$t('chat.reply'), handler: this.reply, data: message })
            }
            if (!this.readOnly && !isSpecialMessage) {
                const fwdStr = isGroupMsgs ? this.$t('chat.group-messages.forward-all') : this.$t('chat.forward')
                if (this.isSelectedMsgs && !isGroupMsgs) handlers.push({ item_name: fwdStr, handler: this.forwardMultple })
                else if (!this.isSelectedMsgs && isGroupMsgs) handlers.push({ item_name: fwdStr, handler: this.forwardGroupMsgs, data: message.groupMsgs })
                else if (!this.isSelectMode) handlers.push({ item_name: fwdStr, handler: this.forward, data: message })
            }
            if (isAdmin && message.cidType === 'group' && !this.isSelectMode) handlers.push({ item_name: this.$t('chat.pin'), handler: this.attachMsg, data: message })
            if (!this.isSelectMode && this[GET_SERVER_API] >= declarations.serverAPILevels.LEVEL_8 &&
                (message.type === 'text' || message.type === 'data' && message.sub_type === 'text' && 
                (!message.author || message.author === message.senderId) && !this.isSelectMode) || 
                (!this.isSelectMode && ['image', 'video', 'file'].includes(message.sub_type))) {
                    handlers.push({ item_name: this.$t('chat.edit'), handler: this[ACT_CHAT_UPDATE_EDITED], data: message })
            }
            if (this.isSelectedMsgs) handlers.push({ item_name: deleteStr, handler: this.deleteMultiple })
            else if (!this.isSelectMode) handlers.push({ item_name: deleteStr, handler: this.removeMsg, data: message })
            return handlers
        },
        leftSideContextMenu(message, isSpecialMessage, isAdmin) {
            const isGroupMsgs = message.hasOwnProperty('groupMsgs')
            const deleteStr = isGroupMsgs ? this.$t('chat.group-messages.delete-all') : this.$t('chat.delete')
            let handlers = []
            if (!this.isSelectMode) {
                handlers.push({ item_name: this.$t('info'), handler: this.showInfoMsg, data: message })
                if (message.senderId !== 0 && message.cidType === 'group') {
                    let cid = message.senderId
                    handlers.push({ item_name: this.$t('information.message'), handler: this.openChat, data: cid })
                }
                if (this.secondContextMenuHandlers.length) {
                    this.secondContextMenuHandlers.forEach(h => {
                        handlers.push(h)
                    })
                    this.secondContextMenuHandlers = []
                }
                if (message.senderId !== 0) handlers.push({ item_name: this.$t('chat.reply'), handler: this.reply, data: message })
            }
            if (!this.readOnly && !isSpecialMessage) {
                if (this.isSelectedMsgs) handlers.push({ item_name:  this.$t('chat.forward'), handler: this.forwardMultple })
                else if (!this.isSelectMode) handlers.push({ item_name:  this.$t('chat.forward'), handler: this.forward, data: message })
            }
            if (isAdmin && message.cidType === 'group' && !this.isSelectMode) handlers.push({ item_name: this.$t('chat.pin'), handler: this.attachMsg, data: message })
            if (this.isSelectedMsgs) {
                handlers.push({ item_name: this.$t('chat.delete'), handler: this.deleteMultiple })
            } else if (!this.isSelectMode) handlers.push({ item_name: deleteStr, handler: this.removeMsg, data: message })
            return handlers
        },
        openChat(cid) {
            const payload = {cid, cidType: 'user', isBot: false}
            this.$store.dispatch('chats/open', payload)
        },
        doSecondContextMenu(handlers) {
            this.secondContextMenuHandlers = handlers
        },
        runBotCommand(e) {
            let { command } = e.detail
            if (command) this.$emit('send', command)
        },
        joinVideoConf({type, vcLink}) {
            this.modalOpen({ component: EnterConf, props: { type, vcLink: vcLink } })
        },
        makeCallByNumber(number) {
            this.$store.dispatch(`${PHONE_CNTL}/${CALLS_CONTROLLER}`, {type: 'call', data: {number, video: false}})
        },
        showInfoMsg: function (message) {
            message.cid = this.cid
            message.notAction = true
            this[ACT_INFO_PUSH]({ type: 'details-msg', params: message })
        },
        removeMsg: function (message) {
            this.modalOpen({
                component: DelChatMessage,
                props: {
                    msg: message,
                    btnOk: {
                        cb: (() =>  { this.$emit('clearselectmode') })
                    }
                }
            })
        },
        copyMultiple() {
            let copiedText = ''
            let msgs = this._getSelectedMessages().sort((a, b) => a.id - b.id)
            msgs.forEach((m, i) => {
                const typeName = this._getDataTypeName(m.data.type)
                const fio = this._getFio(m.senderId)
                const dateTimeText = this._getDateTime(m.timeDetails)
                const itemText = this._getItemText(m)
                let headerText = fio + ' ' + dateTimeText + ':'
                copiedText += headerText + '\n'
                if (typeName) copiedText += typeName + '\n'
                if (itemText && itemText.length) copiedText += itemText + '\n'
                if (copiedText.length && i < msgs.length - 1) copiedText += '\n'
            })
            if (copiedText) this.$copyText(copiedText)
            this.$emit('clearselectmode')
        },
        deleteMultiple() {
            const msgs = this._getSelectedMessages()
            this.modalOpen({
                component: DeleteMultipleMessages,
                props: { msgs, cid: this.cid, cidType: this.cidType,
                    btnOk: {
                        cb: (() =>  { this.$emit('clearselectmode') })
                    }
                }
            })
        },
        forwardMultple() {
            const msgs = this._getSelectedMessages()
            const sortedMsgs = msgs.sort((a, b) => a.id - b.id)
            this.modalOpen({
                component: ForwardMultipleMessages,
                props: { msgs: sortedMsgs,
                    btnOk: {
                        cb: (() =>  { this.$emit('clearselectmode') })
                    }
                }
            })
        },
        _getSelectedMessages() {
            let msgs = []
            this.selectedMessages.map(id => {
                let msg = this.$store.getters['chat/getMessageById'](id)
                msgs.push(msg)
            })
            return msgs
        },
        forwardGroupMsgs(groupMsgs) {
            const msgs = utils.cloneObject(this._getGroupMessages(groupMsgs))
            const newFileGroupId = Date.now().toString(36)
            for (let i = 0; i < msgs.length; i++) {
                const msg = msgs[i]
                msg.data.fileGroupId = newFileGroupId
            }
            const sortedMsgs = msgs.sort((a, b) => a.id - b.id)
            this.modalOpen({
                component: ForwardMultipleMessages,
                props: { msgs: sortedMsgs,
                    btnOk: {
                        cb: (() =>  {})
                    }
                }
            })
        },            
        _getGroupMessages(groupMsgs) {
            let msgs = []
            groupMsgs.map(m => {
                let msg = this.$store.getters['chat/getMessageById'](m.msgId)
                msgs.push(msg)
            })
            return msgs
        },
        forward (message) { // DONE: отправлять в открытые чаты, а не всем пользователям.
            message = JSON.parse(JSON.stringify(message))
            let data = message.msg
            let entities = message.entities
            let dataType, author = message.author ? message.author : message.senderId
            if (message.type === 'text') {
                dataType = declarations.msgDataTypes.MSG_DATA_TYPE_TEXT
            } else {
                if (message.sub_type === 'text') {
                    data = {
                        type: message.sub_type,
                        text: data,
                    }
                    if (!entities) entities = this.extractInputTextFormat(data.text).entities || []
                    data.entities = entities
                } else {
                    data.type = message.sub_type
                }
                if (data.file) {
                    data.file = data.file.split('/').pop();
                }
                if (message.sub_type === 'location') {
                    let { type, latitude, longitude } = data
                    data = { type, latitude, longitude }
                }
                if (message.sub_type === 'contact') {
                    data.fields = message.fields
                }

                data = JSON.stringify(data)
                dataType = declarations.msgDataTypes.MSG_DATA_TYPE_DATA
            }
            this.modalOpen({
                component: SelectChatToForward,
                props: {
                    msg: { dataType, data, author },
                    btnOk: {
                        cb: (() =>  { this.$emit('clearselectmode') })
                    }
                }
            })
        },
        copyToClipboard(data = '') {
            let { text, entities } = data
            let _text
            if (text) {
                if (entities) this[ACT_CHAT_SET_MSG_ENTITIES]({text, entities})
                _text = text
            }
            else {
                _text = data
            }
            this.$copyText(_text, undefined, {
                sourceType: DLP_SOURCE_TYPES.CHAT_MESSAGE,
                sourceData: {
                    id: this.message.id,
                    cid: this.message.cid,
                    cidType: this.message.cidType,
                }
            })
            // this.$emit('clipboardchanged', message);
        },
        reply: function (message) {
            this[ACT_CHAT_UPDATE_REPLY](message)
        },
        doSaveFile(msgIn = null) {
            const msg = msgIn ? msgIn : this.message
            // console.log("🚀 ~ file: ChatMessage.vue:912 ~ doSaveFile ~ msg:", msg)
            this.loadMessageFile({
                id: msg.id,
                file: msg.msg.file,
                size: msg.msg.size
            }, () => { this.downloadFile(msg, true) })
        },
        doLoad() {
            this.loadMessageFile({
                id: this.message.id,
                file: this.message.msg.file,
                size: this.message.msg.size,
                key: this.message.msg.key,
            }, () => {this.downloadFile(this.message)})
        },
        scrollingToElement: function (id) {
            if (id) {
                let element = document.querySelector('#msg' + id)
                element.scrollIntoView({ behavior: 'smooth', block: 'center' })

                setTimeout(function () {
                    element.classList.add('scroll-msg')
                    element.style.opacity = 0.3
                }, 500)
                setTimeout(function () {
                    element.style.opacity = 1
                }, 800)
                setTimeout(function () {
                    element.style.opacity = 0.3
                }, 1100)
                setTimeout(function () {
                    element.style.opacity = 1
                }, 1400)
                setTimeout(function () {
                    element.classList.remove('scroll-msg')
                }, 1700)
            }
        },
        cancelPoll: function () {
            this.$refs.chatPollMessage.cancelPoll()
        },
        attachMsg: function (message) {
            this.modalOpen({
                name: 'confirm',
                props: {
                    text: this.$t('chat.msg-pin-conf'),
                    btnOk: {
                        cb: () => {
                            let { cid, cidType } = this[GET_SELECTED_CHAT]
                            let showAttach = message.showAttach
                            let obj = { cidType, cid, pinMessage: message.id, msg: message }

                            if (showAttach) obj.pinMessage = 0
                            else obj.pinMessage = message.id
                            this.$store.dispatch(`chats/${ACT_CHANGE_CHAT}`, { cid, cidType, pinMessage: message.id })
                        }
                    }
                }
            })
        },
        checkBotMsg (text, textEntities = []) {
            if (text && text.length) {
                const isOldRefFormat = text.search(/(^|[^\S])(?<command>\/(?!\/)\S+)/) > -1
                let isNewRefFormat = false
                if (isOldRefFormat || isNewRefFormat) {
                    this.withText = true
                    return true
                }
                return false
            }
        },
        sendBotCommand (command) {
            this.$emit('send', command)
        },
        openSenderInfo() {
            const isGroup = this.message.cidType === 'group'
            this.openProfile(this.message.senderId, isGroup)
        },
        openProfile(cid, isGroup = false) {
            cid = +cid
            this[ACT_INFO_PUSH]({type: 'contact-info', params: { cid, isGroup }})
        },
        call({cid = false, number = false}) {
            if (cid || number) {
                let data = {cid, number, video: false}
                this.$store.dispatch(`${PHONE_CNTL}/${CALLS_CONTROLLER}`, {type: 'call', data})
            }
        },
        ...mapActions(INFO, [ACT_INFO_PUSH]),
        ...mapActions(CHAT, [ACT_CHAT_UPDATE_REPLY, ACT_CHAT_UPDATE_EDITED, ACT_CHAT_SET_MSG_ENTITIES, ACT_SET_SELECTED_MSGS]),
        ...mapActions(INTEGRATIONS, [ACT_SCHEDULE_RESPONSE_TO_INVITATION]),
        ...mapActions(CONTENT_MANAGER, [ACT_PUSH_MAIN_TYPE]),
    },
}
